import { useServiceWorkerUpdate } from '@/hooks/useServiceWorkerUpdate';

export function UpdateBanner() {
  const { ready, error, apply } = useServiceWorkerUpdate();
  if (error) {
    return (
      <p role="alert" className="bg-red-50 px-4 py-2 text-center text-sm text-red-800">
        Offline use unavailable ({error})
      </p>
    );
  }
  if (!ready) return null;
  return (
    <output className="flex items-center justify-center gap-3 bg-primary-700 px-4 py-2 text-sm text-white">
      A new version of RosaHouse is ready.
      <button
        type="button"
        onClick={apply}
        className="rounded-lg bg-white px-3 py-1 font-medium text-primary-700 hover:bg-primary-50"
      >
        Reload
      </button>
    </output>
  );
}
